var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 279,
    height: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(230,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(219,0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(208,0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(197,0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(186,0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(175,0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(97,0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(86,0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(75,0)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(64,0)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(53,0)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(42,0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C3.69 2 1.38 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(264,0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C3.69 2 1.38 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(253,0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C3.69 2 1.38 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#D9D9D9",
    transform: "translate(242,0)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.33 0.66 6.66 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(164,0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.33 0.66 6.66 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(153,0)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C3.69 2 1.38 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(120,0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C3.69 2 1.38 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(109,0)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.33 0.66 6.66 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#D9D9D9",
    transform: "translate(31,0)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.33 0.66 6.66 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(20,0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.33 0.66 6.66 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(9,0)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(142,0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(131,0)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.68 2 1.36 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#D9D9D9",
    transform: "translate(275,0)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.68 2 1.36 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DADADA",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.6b12918116b9d287a0630ff7627a8671.svg";
export { ForwardRef as ReactComponent };